export const AREA_LIST_FILE_NAME = "AreaRegister";

export const TABLE_HEADERS = [
  { title: "エリアコード", align: "center", sortable: false, key: "area_code" },
  { title: "エリア名", align: "center", sortable: false, key: "area_name" },
  { title: "エリア名(カナ)", align: "center", sortable: false, key: "area_name_kana" },
  { title: "受付可能終了時間", align: "center", sortable: false, key: "acceptable_end_time" },
  { title: "", align: "center", sortable: false, key: "actions" },
];

export const TABLE_UNASSIGNED_LIST_HEADERS = [
  { title: "郵便番号", align: "center", sortable: false, key: "zip_code" },
  { title: "配達区画", align: "left", sortable: false, key: "delivery_area_section" },
];

export const REQUIRED_FIELD_LABEL_KEYS = [
  'lbl_chain_name',
  'lbl_area_name',
  'lbl_area_name_kana',
  'lbl_acceptable_end_time',
  'lbl_shop_name',
] as const;
